import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from '../lib/auth-context'
import LandingPage from '../components/LandingPage'
import LoginPage from '../components/LoginPage'
import RegisterPage from '../components/RegisterPage'
import PasswordSetupPage from '../components/PasswordSetupPage'
import ForgotPasswordPage from '../components/ForgotPasswordPage'
import ResetPasswordPage from '../components/ResetPasswordPage'
import CheckoutSuccessPage from '../components/CheckoutSuccessPage'
import Dashboard from '../components/Dashboard'
import VideoLibrary from '../components/VideoLibrary'
import Resources from '../components/Resources'
import GuideView from '../components/GuideView'
import PromptLibrary from '../components/PromptLibrary'
import HomeworkPage from '../components/HomeworkPage'
import ProfilePage from '../components/ProfilePage'
import TypeformBugReport from '../components/TypeformBugReport'
import AdminDashboard from '../components/AdminDashboard'
import AdminGuides from '../components/admin/AdminGuides'
import AdminGuideViewer from '../components/admin/AdminGuideViewer'
import ProtectedRoute from '../components/ProtectedRoute'
import ProfileCompletionModal from '../components/ProfileCompletionModal'
import PitchScorecards from '../components/PitchScorecards'
import AdvisorHub from '../components/AdvisorHub'
import AdvisorVideos from '../components/AdvisorVideos'
import AdvisorResources from '../components/AdvisorResources'
import AssessmentPage from '../components/AssessmentPage'
import './index.css'

const AppContent = () => {
  const { showProfileCompletion, handleProfileCompletion, skipProfileCompletion, user } = useAuth()

  return (
    <>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/landing" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/setup-password" element={<PasswordSetupPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/checkout-success" element={<CheckoutSuccessPage />} />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/admin" element={
              <ProtectedRoute allowedRoles={['admin', 'staff']}>
                <AdminDashboard />
              </ProtectedRoute>
            } />
            <Route path="/admin/guides" element={
              <ProtectedRoute requireAdmin={true}>
                <AdminGuides />
              </ProtectedRoute>
            } />
            <Route path="/admin/guides/:slug" element={
              <ProtectedRoute requireAdmin={true}>
                <AdminGuideViewer />
              </ProtectedRoute>
            } />
            <Route path="/videos" element={
              <ProtectedRoute>
                <VideoLibrary />
              </ProtectedRoute>
            } />
            <Route path="/resources" element={
              <ProtectedRoute>
                <Resources />
              </ProtectedRoute>
            } />
            <Route path="/resources/:slug" element={
              <ProtectedRoute>
                <GuideView />
              </ProtectedRoute>
            } />
            <Route path="/prompts" element={
              <ProtectedRoute>
                <PromptLibrary />
              </ProtectedRoute>
            } />
            <Route path="/homework" element={
              <ProtectedRoute>
                <HomeworkPage />
              </ProtectedRoute>
            } />
            <Route path="/profile" element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            } />
            <Route path="/report-bug" element={
              <ProtectedRoute>
                <TypeformBugReport />
              </ProtectedRoute>
            } />
            <Route path="/pitch-scorecards" element={
              <ProtectedRoute>
                <PitchScorecards />
              </ProtectedRoute>
            } />
            <Route path="/advisor-hub" element={
              <ProtectedRoute allowedRoles={['advisor', 'investor', 'staff', 'admin']}>
                <AdvisorHub />
              </ProtectedRoute>
            } />
            <Route path="/advisor-hub/videos" element={
              <ProtectedRoute allowedRoles={['advisor', 'investor', 'staff', 'admin']}>
                <AdvisorVideos />
              </ProtectedRoute>
            } />
            <Route path="/advisor-hub/resources" element={
              <ProtectedRoute allowedRoles={['advisor', 'investor', 'staff', 'admin']}>
                <AdvisorResources />
              </ProtectedRoute>
            } />
            <Route path="/assessment" element={
              <ProtectedRoute>
                <AssessmentPage />
              </ProtectedRoute>
            } />
            <Route path="/assessment/:id" element={
              <ProtectedRoute>
                <AssessmentPage />
              </ProtectedRoute>
            } />
          </Routes>
        </div>
      </Router>
      
      {/* Profile Completion Modal */}
      <ProfileCompletionModal
        isOpen={showProfileCompletion}
        onClose={skipProfileCompletion}
        onComplete={handleProfileCompletion}
        user={user}
      />
    </>
  )
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  )
}

export default App

